import React from 'react';
import { makeStyles } from '@material-ui/core';
import OrdersCard from 'components/Cards/OrdersCard/OrdersCard';
import MeetingCard from 'components/Cards/MeetingCard/MeetingCard';
import FeedBackCard from 'components/Cards/FeedBackCard/FeedBackCard';
import DocumentCard from 'components/Cards/DocumentCard/DocumentCard';
// import OrdersTransferCard from 'components/Cards/OrdersTransferCard/OrdersTransferCard';
import ChartAllocationData from '../Feedbacks/charts/ChartAllocationData';
import AvatarSlavcho from '../../../assets/avatars/fakePersons/AvatarSlavcho.png';
import AvatarFaadi from '../../../assets/avatars/fakePersons/AvatarFaadi.png';

const useStyles = makeStyles((tehem) => ({
  feedContainer: {
    flex: 0.5,
    flexDirection: 'column',
    padding: '30px 15px',
    marginRight: 'auto',
    marginTop: '11rem'
  }
}));

const Feed = () => {
  const classes = useStyles();
  return (
    <div className={classes.feedContainer}>
      {/* <OrdersTransferCard /> */}
      <OrdersCard dataviz={<ChartAllocationData id="chartAllocation" />} />
      <FeedBackCard />
      <DocumentCard
        avatar={AvatarFaadi}
        company="equity story"
        name="Faadi Al Rahman"
        status="Lead Financial Advisor"
        text="New update of the"
        time="March 7, 10:34 AM"
      />
      <DocumentCard
        click={() =>
          window.open(
            'http://drivee.praexo.io/api/demofiles/Drivee%20Equity%20Story.pdf',
            '_blank'
          )
        }
        docName="Equity_research.pdf"
        name="Redburn"
        showButton
        status="Equity research and execution firm"
        text="We believe that company offers investors an attractively profitable growth profile in the industry"
        time="March 7, 08:34 AM"
      />
      <DocumentCard
        avatar={AvatarSlavcho}
        click={() =>
          window.open(
            'http://drivee.praexo.io/api/demofiles/INCONNU.pdf',
            '_blank'
          )
        }
        docName="Most_used_valuation_methodologies.pdf"
        name="Slavcho Karbashewski"
        status="Advisor (Praexo)"
        text="Indicative Insight on your capital raising"
        time="March 7, 06:30 AM"
      />
      <MeetingCard />
    </div>
  );
};

export default Feed;
